






























































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
// import { ScanRulesVuex, StoreVuex } from "@root/utiles/constant";
import { handlePaginationDecorator } from "@root/lib/decorator";
import { clearEmptyAttr, showConfirmDialog } from "@root/utiles/common";
import CustomSelect from "@/components/custom/CustomSelect.vue";
import RemoteSelect from "@/components/custom/RemoteSelect.vue";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import { downloadFileByLink } from "@/lib/common";

const root = namespace("root");
const common = namespace("common");
const rewardAccounting = namespace("rewardAccounting");
const credit = namespace("credit");
@Component({
  components: {
    CustomSelect,
    RemoteSelect
  }
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class WtStoreManagement extends Vue {
  @root.State ddCodes;
  @common.Action queryDataDictionaryListLang;
  @rewardAccounting.Action storeSimplePaging;
  @credit.Action queryCreditLogList;
  @credit.Action exportCreditLog;
  @common.Action getDict;

  private dataList = [];
  gtExportDialog = false;
  exportParams = {};
  dialogVisible: any = false;
  changeTypeList: any[] = [
    // { value: "1", label: "授权调整" },
    // { value: "2", label: "下单使用" },
    // { value: "3", label: "客户回款" }
  ];
  // 搜索参数
  private form: any = {
    storeCodeOrName: "",
    creditLogType: "",
    orderCode: "",
    updateTime: null
  };
  searchParams: any = {};

  async created() {
    this.getData();
    this.getDicList();
  }
  async mounted() {}

  @loadingCatch
  async getData() {
    let memberCode: any = localStorage.getItem("memberCode");
    const { pageSize, currentPage: pageNum } = this as any;
    let { updateTime = [], ...others } = this.form;
    let input: any = {
      shopCodeOrName: memberCode,
      pageSize,
      pageNum,
      ...others
    };
    this.searchParams = input;
    if (updateTime) {
      if (updateTime[0]) {
        input.startTime = updateTime[0];
      }
      if (updateTime[1]) {
        input.endTime = updateTime[1];
      }
    }
    try {
      let res = await this.queryCreditLogList(input);
      this.dataList = res.list || [];
      (this as any).total = res.total || 0;
    } catch (e) {
      console.log(e);
    }
  }

  handleStoreSelect(data) {
    this.form.storeCode = data ? data.storeCode : "";
    console.log(data, "-handleStoreSelect-");
  }
  exportLoading: any = false;
  // 导出
  async exportFn() {
    try {
      this.exportLoading = true;

      let { pageSize, pageNum, ...others } = this.searchParams;

      let res: any = await this.exportCreditLog({
        exportType: "1",
        ...others
      });
      downloadFileByLink(res);
    } finally {
      this.exportLoading = false;
    }
  }
  async getDicList() {
    let res = await this.getDict({
      dictCodes: ["CREDIT_LOG_TYPE"]
    });
    let dicMap: any = {};
    res.forEach(_ => {
      dicMap[_.code] = _.value || [];
    });
    this.changeTypeList = dicMap["CREDIT_LOG_TYPE"];
  }
}
